import { Link } from 'react-router-dom';
import useLogin from '@/hooks/useLogin';
import { DataForm } from '@design-system/DataForm/DataForm';
import { TextField } from '@design-system/DataForm/TextField';
import { PasswordField } from '@design-system/DataForm/PasswordField';
import { Button } from '@design-system/Button';
import { PASSWORD_RECOVERY_PATH } from '@/constants/paths';
import { UnprotectedRouteContainer } from '@/utils/UnprotectedRouteContainer';
import CircularLoader from '@/components/utils/CircularLoader';

export const MobileWebLogin = ({
  showLogin,
}: {
  showLogin: (login: boolean) => void;
}) => {
  const { onValid, form, showErrorMessage, isLoading } = useLogin();

  return (
    <UnprotectedRouteContainer
      footer={
        <p className="mt-6 text-xs text-center">
          By logging in, you agree to our{' '}
          <a href="#" className="underline">
            Terms of Services
          </a>
          .
        </p>
      }
      showLogin={showLogin}
    >
      <h2 className="text-3xl font-sans md:text-center font-medium mb-8">
        Login to Viome
      </h2>
      <DataForm form={form} onValid={onValid}>
        <TextField name="email" placeholder="Email" required />
        <PasswordField name="password" placeholder="Password" required />

        {showErrorMessage && (
          <p className="typography-btn-small text-destructive text-center">
            Invalid username or password
          </p>
        )}

        <Button
          type="submit"
          disabled={isLoading}
          className="w-full mt-6 py-3 text-white font-semibold bg-black rounded-lg"
        >
          {isLoading ? <CircularLoader /> : 'Login'}
        </Button>

        <Link
          to={PASSWORD_RECOVERY_PATH}
          className="block mt-4 text-sm text-center hover:underline"
        >
          Forgot password
        </Link>
      </DataForm>
    </UnprotectedRouteContainer>
  );
};
